import { createContext } from 'react';

const ArchiveFilesPageManagerContext = createContext();

export default ArchiveFilesPageManagerContext;
